<template lang="pug">
  v-card.mx-auto
    v-card-title Casos diarios
    GChart(v-if="chartData.length > 0", type="LineChart", :data="chartData", :options="chartOptions")
    v-card-text.text--primary
      div Casos confirmados acumulados por día
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart
  },
  props: {
    limit: {
      type: Number,
      default: 9
    },
    nationalConfirmed: {
      type: Array
    }
  },
  data() {
    return {
      chartData: [],
      chartOptions: {
        // title: 'Confirmados por día',
        curveType: 'function',
        // subtitle: 'Casos confirmados',
        legend: { position: 'bottom' },
        hAxis: {
          slantedTextAngle: 45
        }
      },
      confirmedShow: []
    }
  },
  watch: {
    nationalConfirmed: function() {
      this.reloadChart()
    }
  },
  methods: {
    reloadChart() {
      let slicePart = Math.trunc((this.nationalConfirmed.length - 1) / this.limit)

      let initRow = this.nationalConfirmed.length - (this.nationalConfirmed.length-slicePart*this.limit)

      this.chartData = [['Día', 'Confirmados acumulados', 'Muertes']]
      for (let i = initRow; i >= 0; i = i - slicePart) {
        this.chartData.push([
          this.$options.filters.dateFormatString(this.nationalConfirmed[i].date).slice(0, 5),
          this.nationalConfirmed[i].confirmed,
          parseInt(this.nationalConfirmed[i].deaths)
        ])
      }
    }
  },
  mounted() {
    this.reloadChart()
  }
}
</script>
